import angular from 'angular';

import { BehaviorSubject } from 'rxjs';
import { getCapabilitySpecifications } from 'src/app/shared/capabilities-and-permissions';
import { CapabilityIdEnum } from 'src/app/shared/capabilities-and-permissions/capability-id.enum';
import { copyInputToClipboard } from './../parameters/quick-replies/joint-diagram/shared/helpers';

UserEditionController.$inject = ['$scope', '$state', '$stateParams', '$translate', 'TopToolbarFactory', 'UsersRolesFactory', 'AngularUsersService', 'DropdownItemsFactory', 'AlertingFactory', 'ConfirmationFactory', 'MediasFactory', 'company', 'AngularSitesService', 'AngularSpinnerService'];
export function UserEditionController($scope, $state, $stateParams, $translate, TopToolbarFactory, UsersRolesFactory, AngularUsersService, DropdownItemsFactory, AlertingFactory, ConfirmationFactory, MediasFactory, company, AngularSitesService, AngularSpinnerService) {
  $scope.updateSaveBtn = updateSaveBtn;
  $scope.onUploadImgClick = onUploadImgClick;
  $scope.deletePersonaImg = deletePersonaImg;
  $scope.goBack = goBack;

  $scope.updateUserTeams = updateUserTeams;

  $scope.generatePassResetLink = generatePassResetLink;
  $scope.copyPassLinkToClipboard = copyPassLinkToClipboard;

  $scope.onSwitchChange = onSwitchChange;


  $scope.rolesSelectionChanged = rolesSelectionChanged;
  $scope.rolesBS = new BehaviorSubject(null);

  $scope.groupPermissionColumnChange = groupPermissionColumnChange;
  $scope.groupPermissionLineChange = groupPermissionLineChange;
  $scope.siteGroupPermissionChange = siteGroupPermissionChange;
  $scope.groupPermissionsColumnMap = new Map();
  $scope.sitesGroupPermissionsMap = new Map();
  $scope.disabledSitesGroupPermissionsMap = new Map();

  $scope.permissionsGroupsBS = new BehaviorSubject(null);

  $scope.permissionColumnChange = permissionColumnChange;
  $scope.permissionLineChange = permissionLineChange;
  $scope.sitePermissionChange = sitePermissionChange;
  $scope.permissionsColumnMap = new Map();
  $scope.sitesPermissionsMap = new Map();
  $scope.disabledSitesPermissionsMap = new Map();
  $scope.permissionsBS = new BehaviorSubject(null);
  $scope.sitesReference = []
  $scope.sitesIdsReferenceSet = new Set();
  $scope.sitesGroupsReference = []
  $scope.switches = ['is_admin', 'hide_from_stats', 'is_in_push_mode'];
  $scope.disabledSwitches = [];
  $scope.userNameMaxLength = 40;

  init();

  function init() {

    $scope.sortColumn = 'label';
    $scope.teamsLabel = $translate.instant('users_roles/teams');
    $scope.sitesLabel = $translate.instant('users_roles/sites');
    $scope.rolesLabel = $translate.instant('users_roles/roles');
    $scope.specialPermissionsLabel = $translate.instant('users_roles/special_permissions');
    $scope.backToLabel = $translate.instant('users_roles/back_to_users_table');
    $scope.noTeamsDefinedLabel = $translate.instant('users_roles/no_teams_defined');
    $scope.genPassResetLinkLabel = $translate.instant('users_roles/gen_pass_reset_link');

    $scope.allSites = DropdownItemsFactory.buildSiteItems(AngularSitesService.sitesV2);
    UsersRolesFactory.sortUsersSitesRoles($scope.allSites, 'label');

    $scope.routingTagExists = company.tags_groups.some(obj => obj.is_routing === 1); // Check if the routing_tag for this company exists
    UsersRolesFactory.getTeams(company.id, $scope.routingTagExists)
      .then(res => {
        $scope.allTeams = res.data;
        $scope.allTeams.forEach(team => team.id = team.tag_id);
        $scope.allTeams.forEach(team => team.label = team.name);
      }, AlertingFactory.httpErrorHandler());

    // Tooltips
    $scope.userTooltips = {
      email: $translate.instant('users_roles/user_edition/tooltips/email'),
      persona: $translate.instant('users_roles/user_edition/tooltips/persona'),
      active: $translate.instant('users_roles/user_edition/tooltips/active'),
      admin: $translate.instant('users_roles/user_edition/tooltips/admin'),
      hideFromStats: $translate.instant('users_roles/user_edition/tooltips/appearsInDropdown'),
      pushMode: $translate.instant('users_roles/user_edition/tooltips/pushMode'),
      passReset: $translate.instant('users_roles/user_edition/tooltips/passReset')
    };

    TopToolbarFactory.setFirstLevelNavTranslation('menu/admin/users', $scope, () => UsersRolesFactory.redirectToUsersTeamsRoles($state));
    TopToolbarFactory.setButton('save', save, $scope);

    $scope.allPermissions = getCapabilitySpecifications();
    $scope.allPermissions.forEach(permission => {
      $scope.permissionsColumnMap.set(permission.id, new Set())
    });


    AngularUsersService.getRoles(company.id)
      .toPromise()
      .then(res => {
        $scope.allRoles = res;
        $scope.rolesBS.next($scope.allRoles);
        $scope.allRoles.forEach(role => role.label = role.name);
        UsersRolesFactory.sortUsersSitesRoles($scope.allRoles, 'name');

        UsersRolesFactory.getUserById(company.id, $stateParams.id)
          .then(res => {
            $scope.user = res.data;

            _initPermissionsPerSite();
            TopToolbarFactory.setTitle($scope.user.email, $scope);

            // Persona image
            if ($scope.user.persona && $scope.user.persona.image_id) {
              $scope.user.persona.image = MediasFactory.pictureUrl(company.id, $scope.user.persona.image_id);
            }

            // User & role switches 
            $scope.userSwitchesValues = [];
            $scope.switches.forEach(sw => $scope.userSwitchesValues[sw] = $scope.user[sw]); // Keep track of user values for the switches
            $scope.disabledSwitches = [];
            _updateSwitchesValueFromRoles();

          }, AlertingFactory.httpErrorHandler());
      }, AlertingFactory.httpErrorHandler());


    // Persona image
    $scope.$watch('filenames.picture', file => {
      if (file) {
        $scope.uploadingPicture = true;
        MediasFactory.upload2(company.id, 0, 'image', file,
          response => {
            $scope.uploadingPicture = false;
            $scope.user.persona.image_id = response.data.media_id;
            $scope.user.persona.image = MediasFactory.pictureUrl(company.id, $scope.user.persona.image_id);
          },
          response => {
            $scope.uploadingPicture = false;
            AlertingFactory.error(response && response.data && response.data.error ? response.data.error : 'common/http_error');
          });

        updateSaveBtn();
      }
    });

  }

  function _initPermissionsPerSite() {
    $scope.allPermissions = getCapabilitySpecifications();
    $scope.allPermissions.forEach(permission => {
      $scope.groupPermissionsColumnMap.set(permission.id, new Set())
      $scope.permissionsColumnMap.set(permission.id, new Set())
    });

    $scope.sitesGroupsReference = DropdownItemsFactory.buildSiteGroupItems(AngularSitesService.siteGroupsV2)
      .filter(({ id }) => Object.keys(AngularSitesService.siteGroupsV2Map.get(id).sites)?.length);
    $scope.sitesGroupsIdsReference = $scope.sitesGroupsReference.map(({ id }) => id);

    $scope.sitesReference = DropdownItemsFactory.buildSiteItems(AngularSitesService.sitesV2.filter(({ site_group_id }) => !site_group_id));
    $scope.sitesIdsReference = $scope.sitesReference.map(({ id }) => {
      $scope.sitesIdsReferenceSet.add(id);
      return id;
    });

    $scope.sitesGroupsIdsReference.forEach(siteGroupId => {
      $scope.sitesGroupPermissionsMap.set(siteGroupId, new Set())
      $scope.disabledSitesGroupPermissionsMap.set(siteGroupId, new Set())
    });

    _computesPermissionsFromRoles();

    $scope.sitesIdsReference.forEach(siteId => $scope.sitesPermissionsMap.set(siteId, new Set()));
    if ($scope.user.capabilities_by_site_id) {
      const customPermissions = Object.keys($scope.user.capabilities_by_site_id) || [];
      $scope.hasNotCustomPermissions = !customPermissions.length;
      customPermissions.forEach((siteId) => {
        $scope.sitesPermissionsMap.set(+siteId, new Set($scope.user.capabilities_by_site_id[+siteId]));
        $scope.user.capabilities_by_site_id[+siteId].forEach(id => $scope.permissionsColumnMap.get(+id)?.add(+siteId));
      });
    }

    _refreshPermissionsPerAccountsGroup();
    _refreshPermissionsPerAccount();

    disableSave();
  }

  function permissionColumnChange(permission) {
    const { id: permissionId } = permission;
    const currentLength = $scope.permissionsColumnMap.get(permissionId).size;


    if (!currentLength || $scope.permissionsColumnMap.get(permissionId).size < $scope.sitesIdsReference.length) {
      // If partial or no selection, add all.
      $scope.sitesIdsReference.forEach(siteId => {
        $scope.sitesPermissionsMap.get(siteId).add(permissionId);
        $scope.permissionsColumnMap.get(permissionId).add(siteId);
      });
    } else {
      $scope.permissionsColumnMap.get(permissionId).clear();
      $scope.sitesReference.forEach(site => $scope.sitesPermissionsMap.get(site.id).delete(permissionId));
    }
    _refreshPermissionsPerAccount();

  }

  function permissionLineChange(siteId) {
    const currentLength = $scope.sitesPermissionsMap.get(siteId).size;


    if (!currentLength || $scope.sitesPermissionsMap.get(siteId).size < $scope.allPermissions.length) {
      // If partial or no selection, add all.
      $scope.allPermissions.forEach(({ id }) => {
        $scope.sitesPermissionsMap.get(siteId).add(id);
        $scope.permissionsColumnMap.get(id).add(siteId);
      });
    } else {
      $scope.sitesPermissionsMap.get(siteId).clear();
      $scope.allPermissions.forEach(({ id }) =>
        $scope.permissionsColumnMap.get(id).delete(siteId)
      );
    }

    _refreshPermissionsPerAccount();

  }

  function sitePermissionChange({ siteId, permissionId }) {
    if ($scope.sitesPermissionsMap.get(siteId).has(permissionId)) {
      $scope.sitesPermissionsMap.get(siteId).delete(permissionId);
      $scope.permissionsColumnMap.get(permissionId).delete(siteId);
    } else {
      $scope.sitesPermissionsMap.get(siteId).add(permissionId);
      $scope.permissionsColumnMap.get(permissionId).add(siteId);
    }
    _refreshPermissionsPerAccount();
  }

  function groupPermissionColumnChange(permission) {
    const { id: permissionId } = permission;
    const currentLength = $scope.groupPermissionsColumnMap.get(permissionId).size;

    if (!currentLength || $scope.groupPermissionsColumnMap.get(permissionId).size < $scope.sitesGroupsIdsReference.length) {
      // If partial or no selection, add all.
      $scope.sitesGroupsIdsReference.forEach(siteId => {
        $scope.sitesGroupPermissionsMap.get(siteId).add(permissionId);
        $scope.groupPermissionsColumnMap.get(permissionId).add(siteId);
      });
    } else {
      $scope.groupPermissionsColumnMap.get(permissionId).clear();
      $scope.sitesGroupsReference.forEach(site => $scope.sitesGroupPermissionsMap.get(site.id).delete(permissionId));
    }
    _refreshPermissionsPerAccountsGroup();

  }

  function groupPermissionLineChange(siteId) {

    const currentLength = $scope.sitesGroupPermissionsMap.get(siteId).size;


    if (!currentLength || $scope.sitesGroupPermissionsMap.get(siteId).size < $scope.allPermissions.length) {
      // If partial or no selection, add all.
      $scope.allPermissions.forEach(({ id }) => {
        $scope.sitesGroupPermissionsMap.get(siteId).add(id);
        $scope.groupPermissionsColumnMap.get(id).add(siteId);
      });
    } else {
      $scope.sitesGroupPermissionsMap.get(siteId).clear();
      $scope.allPermissions.forEach(({ id }) =>
        $scope.groupPermissionsColumnMap.get(id).delete(siteId)
      );
    }
    _refreshPermissionsPerAccountsGroup();

  }

  function siteGroupPermissionChange({ siteId, permissionId }) {
    if ($scope.sitesGroupPermissionsMap.get(siteId).has(permissionId)) {
      $scope.sitesGroupPermissionsMap.get(siteId).delete(permissionId);
      $scope.groupPermissionsColumnMap.get(permissionId).delete(siteId);
    } else {
      $scope.sitesGroupPermissionsMap.get(siteId).add(permissionId);
      $scope.groupPermissionsColumnMap.get(permissionId).add(siteId);
    }
    _refreshPermissionsPerAccountsGroup();
  }

  function _refreshPermissionsPerAccountsGroup() {
    $scope.permissionsGroupsBS.next({
      columnMap: $scope.groupPermissionsColumnMap,
      lineMap: $scope.sitesGroupPermissionsMap,
      disabledMap: $scope.disabledSitesGroupPermissionsMap,
    });
    updateSaveBtn();
  }

  function _refreshPermissionsPerAccount() {
    $scope.permissionsBS.next({
      columnMap: $scope.permissionsColumnMap,
      lineMap: $scope.sitesPermissionsMap,
      disabledMap: $scope.disabledSitesPermissionsMap,
    });
    updateSaveBtn();
  }

  function _computesPermissionsFromRoles() {
    $scope.sitesGroupsIdsReference.forEach(siteGroupId => $scope.disabledSitesGroupPermissionsMap.set(+siteGroupId, new Set()));
    $scope.sitesIdsReference.forEach(siteId => $scope.disabledSitesPermissionsMap.set(siteId, new Set()));

    $scope.user.roles.forEach((roleId) => {
      const role = AngularUsersService.roleMap.get(roleId);
      Object.keys(role.capabilities_by_site_group_id || []).forEach(siteGroupId => {
        (role.capabilities_by_site_group_id[+siteGroupId] || []).forEach(permissionId =>
          $scope.disabledSitesGroupPermissionsMap.set(+siteGroupId, $scope.disabledSitesGroupPermissionsMap.get(+siteGroupId).add(permissionId))
        )
      });
      if (role.capabilities_by_site_id) {
        (Object.keys(role.capabilities_by_site_id) || []).forEach((siteId) => {
          (role.capabilities_by_site_id[+siteId] || []).forEach(permissionId =>
            $scope.disabledSitesPermissionsMap.set(+siteId, $scope.disabledSitesPermissionsMap.get(+siteId).add(permissionId))
          )
        });
      }
    });
  }

  function enableSave() {
    TopToolbarFactory.updateButtonDisable(false, $scope);
  }

  function disableSave() {
    TopToolbarFactory.updateButtonDisable(true, $scope);
  }

  function updateSaveBtn() {
    if ($scope.user?.name) {
      enableSave();
    } else {
      disableSave();
    }
  }

  function save() {
    $scope.disabledSitesPermissionsMap.forEach((values, key) => values.forEach(value => $scope.sitesPermissionsMap.get(key).delete(value)));
    const capabilities = Object.fromEntries($scope.sitesPermissionsMap);
    const allowedCapabilities = Object.values(CapabilityIdEnum);
    Object.keys(capabilities).forEach(siteId => {
      const capabilitiesCleaned = [...capabilities[siteId]].filter(permissionId => allowedCapabilities.includes(permissionId));
      capabilities[siteId] = new Set(capabilitiesCleaned);
    });
    $scope.user.capabilities_by_site_id = capabilities;

    // Update the user
    UsersRolesFactory.updateUser(company.id, $scope.user)
      .then(() => {
        AlertingFactory.success('users_roles/update_user_success');
        disableSave();
      },
        AlertingFactory.httpErrorHandler());

  }

  // Check if the switch is enabled through a role and add it to the list of disabled switches - if it is not enabled it is removed from the list
  function _updateSwitchesValueFromRoles() {
    $scope.switches.forEach(sw => {
      if ($scope.user.roles && $scope.user.roles.map(role => $scope.allRoles.find(r => r.id === role))
        .some(role => role[sw] === 1)) {
        // Disable the switch and then activate it (because a role has this one enabled)
        $scope.disabledSwitches.push(sw);
        $scope.user[sw] = 1;
      } else {
        // Remove from disabled and restore user value (if no role has this one enabled)
        $scope.disabledSwitches = $scope.disabledSwitches.filter(s => s !== sw);
        $scope.user[sw] = $scope.userSwitchesValues[sw];
      }
    });
  }

  function onUploadImgClick() {
    angular.element('#persona-img-input').click();
  }

  function deletePersonaImg() {
    ConfirmationFactory.materialConfirmDialog('users_roles/confirm_persona_image_deletion')
      .then(function () {
        $scope.user.persona.image_id = null;
        $scope.user.persona.image = null;

        updateSaveBtn();
      }, AlertingFactory.httpErrorHandler());
  }

  function onSwitchChange(sw) {
    // Called only when the user explicitly changes the switch
    $scope.userSwitchesValues[sw] = $scope.user[sw];

    updateSaveBtn();
  }

  // Remove team if it's already included, add it otherwise
  function updateUserTeams(team) {
    $scope.user.teams.includes(team.id)
      ? $scope.user.teams = $scope.user.teams.filter(id => id !== team.id)
      : $scope.user.teams.push(team.id);
  }

  // Go back to users table
  function goBack() {
    UsersRolesFactory.redirectToUsersTeamsRoles($state, 0);
  }

  function rolesSelectionChanged(roles) {
    $scope.user.roles = roles;
    _updateSwitchesValueFromRoles();
    _computesPermissionsFromRoles();

    updateSaveBtn();
  }

  // Create a password reset link and display it to the user
  function generatePassResetLink() {
    AngularSpinnerService.showSpinner();
    UsersRolesFactory.generatePassResetLink(company.id, $scope.user.id)
      .then(res => {
        $scope.passResetLink = res.data.url;
        $scope.passResetBtnClicked = true;
      }, AlertingFactory.httpErrorHandler())
      .finally(() => AngularSpinnerService.hideSpinner());
  }

  function copyPassLinkToClipboard(passLink) {
    const messages = {
      success: 'users_roles/copy_pass_link_success',
      error: 'users_roles/copy_pass_link_error'
    };

    copyInputToClipboard({ AlertingFactory }, passLink, messages);
  }

}
